export const browserRedirectToPage = (url: string) => {
    if (typeof window !== "undefined") {
        window.location.href = url;
    }
}